query TagGroupDetails($id: UUID!) {
  tagGroup(id: $id) {
    id
    _rowTimestamp
    name
    description
    _isUpdatable
    _isDeletable
    tagGroupItemsByTagGroupId(orderBy: _TAG_BADGE_NAME_ASC) {
      nodes {
        id
        tagId
        _rowTimestamp
        _tagBadgeName
        tag {
          badgeColor
        }
      }
    }
  }
}
